(() => {
  const protectedSelectors = [
    'img',
    'picture',
    'video',
    'model-viewer',
    '.media',
    '.product__media',
    '.deferred-media',
    '.card__media',
    '.banner__media',
    '.slideshow__media',
    '.home-hero__card',
    '.proof-collage__item',
    '.unboxing-video__media',
    '.artwork-process-flow__video-media'
  ].join(',');

  const protectedMedia = (target) => target?.closest?.(protectedSelectors);

  const preventMediaAction = (event) => {
    if (protectedMedia(event.target)) {
      event.preventDefault();
      return false;
    }
  };

  const protectNode = (node) => {
    if (!node?.querySelectorAll) return;

    const media = node.matches?.('img, video, picture, model-viewer')
      ? [node]
      : Array.from(node.querySelectorAll('img, video, picture, model-viewer'));

    media.forEach((element) => {
      element.setAttribute('draggable', 'false');

      if (element.tagName === 'IMG') {
        element.setAttribute('loading', element.getAttribute('loading') || 'lazy');
      }

      if (element.tagName === 'VIDEO') {
        element.setAttribute('controlsList', 'nodownload noplaybackrate');
        element.setAttribute('disablePictureInPicture', '');
      }
    });
  };

  document.addEventListener('contextmenu', preventMediaAction, true);
  document.addEventListener('dragstart', preventMediaAction, true);
  document.addEventListener('selectstart', preventMediaAction, true);

  document.addEventListener('DOMContentLoaded', () => {
    protectNode(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(protectNode);
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
})();
